import { css } from "@emotion/react";
import { fade } from "@material-ui/core/styles";

import checkIcon from "../../assets/images/symbol-icn-check.svg";
import theme from "../../styles/theme";
import { greyDark, blue, red, white } from "../../styles/variables";

const { spacing } = theme;

export const paper = css`
  position: relative;
  padding: ${spacing(4.5)}px;
`;

export const chip = css`
  position: absolute;
  right: 0;
  top: 12px;
  background-color: ${red};
  border-radius: 4px 0 0 4px;
  padding: ${spacing(0.5, 1)};
  color: ${white};
  font-size: 14px;
  z-index: 2;

  .MuiChip-label {
    padding: 0;
  }
`;

export const titleBlock = css`
  margin-bottom: ${spacing(2)}px;
`;

export const priceBlock = css`
  margin-bottom: ${spacing(2.5)}px;
  font-weight: bold;
  font-size: 24px;
`;

export const percent = css`
  margin-left: ${spacing(1.25)}px;
  font-weight: bold;
  font-size: 12px;
`;

export const currency = css`
  margin-top: ${spacing(1)}px;
`;

export const descriptionBlock = css`
  margin-bottom: ${spacing(2.5)}px;
  color: ${greyDark};
  font-size: 12px;
`;

export const descriptionWithoutBtn = css`
  margin-bottom: ${spacing(5)}px;
`;

export const btn = css`
  width: 100%;
  margin-bottom: ${spacing(5)}px;
`;

export const detail = css`
  list-style-type: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: ${spacing(2.5)}px;
  }
`;

export const detailLabelBlock = css`
  display: flex;
  align-items: flex-start;
`;

export const checkbox = css`
  padding: 0;
  margin: ${spacing("3px", 1.25, 0, 0)};
  pointer-events: none;
`;

export const checkboxCheckedIcon = css`
  background-color: ${fade(blue, 0.2)};
  border-radius: 50%;
  width: 16px;
  height: 16px;

  &::before {
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    background-image: url(${checkIcon});
    background-size: cover;
    margin: 3px;
  }
`;

export const detailLabel = css`
  font-weight: bold;
  font-size: 14px;
  white-space: pre-wrap;
`;

export const detailText = css`
  margin: ${spacing(0, 0, 1, "25px")};
  &:first-of-type {
    margin-top: ${spacing(1)}px;
  }

  display: flex;
  align-items: center;
`;

export const policy = css`
  font-weight: normal;
`;

export const btnChangePlan = css`
  margin-top: ${spacing(1.5)}px;
  font-weight: bold;
  display: block;
`;
